import React from "react";

const FilesStatisticsChart = ({ fileStatData }) => (
  <div className="p-sm-0">
    <p className="mb-4">
      <strong>Files statistics</strong>
    </p>
    <table className="table table-sm table-bordered">
      <thead>
        <tr>
          <th>Format</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {fileStatData && fileStatData.map((entry, idx) => (
          <tr key={idx}>
            <td className="text-uppercase small">{entry.Name && entry.Name.toUpperCase()}</td>
            <td>{entry.Total}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default FilesStatisticsChart;
